/**
 * The app's icon set: inline SVG, 24 px grid, 2 px strokes, drawn for this
 * app. No icon font and no request to anywhere (CSP default-src 'self').
 */
const PATHS = {
  plane: 'M12 2.5c.9 0 1.4.9 1.4 2.2v5.1l7.6 4.1v2.2l-7.6-2.2v4.4l2.2 1.6v1.6L12 20.6l-3.6 1v-1.6l2.2-1.6v-4.4L3 16.1v-2.2l7.6-4.1V4.7c0-1.3.5-2.2 1.4-2.2z',
  search: 'M10.5 4a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13zM15.2 15.2 21 21',
  inbox: 'M3 13l2.5-8h13L21 13v6H3zM3 13h5l1.5 2.5h5L16 13h5',
  user: 'M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM4 21c.8-4 4-6 8-6s7.2 2 8 6',
  admin: 'M12 3l7 3v5c0 4.5-3 8.3-7 10-4-1.7-7-5.5-7-10V6zM9 12l2 2 4-4',
  plus: 'M12 5v14M5 12h14',
  minus: 'M5 12h14',
  fit: 'M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5',
  close: 'M6 6l12 12M18 6 6 18',
  back: 'M15 5l-7 7 7 7',
  forward: 'M9 5l7 7-7 7',
  down: 'M6 9l6 6 6-6',
  camera: 'M4 8h3l2-3h6l2 3h3v11H4zM12 17a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z',
  image: 'M4 5h16v14H4zM4 16l5-5 4 4 2-2 5 5M15.5 9.5a1 1 0 1 0 0-.1',
  trash: 'M4 7h16M10 7V4h4v3M6 7l1 13h10l1-13M10 11v6M14 11v6',
  undo: 'M9 14 4 9l5-5M4 9h10a6 6 0 0 1 0 12h-3',
  edit: 'M4 20h4L19 9l-4-4L4 16zM13 7l4 4',
  check: 'M5 12.5l4.5 4.5L19 7',
  merge: 'M6 4v4a6 6 0 0 0 6 6h0a6 6 0 0 1 6 6M18 4v4a6 6 0 0 1-3 5.2M15 17l3 3 3-3',
  reject: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM8.5 8.5l7 7M15.5 8.5l-7 7',
  list: 'M9 6h11M9 12h11M9 18h11M4.5 6h.01M4.5 12h.01M4.5 18h.01',
  map: 'M3 6l6-2 6 2 6-2v14l-6 2-6-2-6 2zM9 4v14M15 6v14',
  filter: 'M4 5h16l-6 7.5V19l-4 2v-8.5z',
  offline: 'M3 3l18 18M8.5 8.6A5 5 0 0 0 6.2 18H17M17.8 11.2A5 5 0 0 0 12.6 7a5 5 0 0 0-1.3.2M19.8 16.4A3.5 3.5 0 0 0 18 12',
  eye: 'M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12zM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
  // "In Reparatur". The wrench it replaces read as a brush at 18 px (owner, 05.10.2026).
  hammer: 'M5 19l8.7-8.7M12.8 4.2l7 7-2.6 2.6-7-7z',
  // Videos (stage 2): a triangle to play, a camcorder to record.
  play: 'M8 5v14l11-7z',
  video: 'M3 7h12v10H3zM15 10l6-3v10l-6-3',
  // Akzeptiert: level, as it is.
  level: 'M5 10h14M5 14h14',
  resolve: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM8 12.5l2.8 2.8L16.5 9.5',
  reopen: 'M4 12a8 8 0 1 0 2.3-5.7M4 4v5h5',
  message: 'M4 5h16v11H9l-5 4zM8 9.5h8M8 12.5h5',
  clock: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 7v5l3.5 2',
  alert: 'M12 3.5l9.5 16.5h-19zM12 10v4.5M12 17.5v.01',
  logout: 'M15 4h4v16h-4M10 8l-4 4 4 4M6 12h10',
  star: 'M12 3.5l2.6 5.4 5.9.8-4.3 4.1 1 5.8-5.2-2.8-5.2 2.8 1-5.8L3.5 9.7l5.9-.8z',
  mirror: 'M12 3v18M9 6 3 18h6zM15 6l6 12h-6z',
  pin: 'M12 21s-6.5-6-6.5-11a6.5 6.5 0 0 1 13 0c0 5-6.5 11-6.5 11zM12 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z',
  sun: 'M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM12 2v2M12 20v2M2 12h2M20 12h2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4',
  upload: 'M12 16V4M7 9l5-5 5 5M4 16v4h16v-4',
  people: 'M9 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM2.5 20c.6-3.5 3.2-5.5 6.5-5.5s5.9 2 6.5 5.5M16 4.3a3.5 3.5 0 0 1 0 6.4M18 14.8c2 .7 3.2 2.5 3.5 5.2',
  history: 'M3 12a9 9 0 1 0 3-6.7M3 4v5h5M12 7.5V12l3 2',
  sliders: 'M4 6h10M18 6h2M4 12h4M12 12h8M4 18h12M20 18h0M14 4v4M8 10v4M16 16v4',
  refresh: 'M20 11a8 8 0 0 0-14.3-4.9L4 8M4 4v4h4M4 13a8 8 0 0 0 14.3 4.9L20 16M20 20v-4h-4',
  external: 'M14 4h6v6M20 4l-9 9M18 14v6H4V6h6',
  club: 'M3 21h18M5 21V10l7-5 7 5v11M9 21v-6h6v6M12 5V2.5l3 1.2-3 1.3',
  key: 'M14.5 9.5a4 4 0 1 0-1.2 2.9L21 20M17 16l2-2M15 14l1.5-1.5M7.5 9.5h.01',
  platform: 'M4 4h7v7H4zM13 4h7v7h-7zM4 13h7v7H4zM13 16.5h7M16.5 13v7',
  lock: 'M6 11h12v9H6zM8.5 11V8a3.5 3.5 0 0 1 7 0v3',
  swap: 'M7 4 3 8l4 4M3 8h14M17 12l4 4-4 4M21 16H7',
  help: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM9.4 9.3a2.7 2.7 0 0 1 5.2 1c0 1.8-2.6 2.2-2.6 4M12 17.3v.01',
  flag: 'M5 21V4M5 4h11l-2 4 2 4H5',
  download: 'M12 4v11M7 10l5 5 5-5M5 20h14',
  receipt: 'M6 3h12v18l-3-2-3 2-3-2-3 2zM9 8h6M9 12h6M9 16h3',
} as const;

export type IconName = keyof typeof PATHS;

export function Icon({ name, size = 22, title }: { name: IconName; size?: number; title?: string }) {
  const filled = name === 'plane';
  return (
    <svg
      className="icon"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={filled ? 'currentColor' : 'none'}
      stroke={filled ? 'none' : 'currentColor'}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden={title ? undefined : true}
      role={title ? 'img' : undefined}
      focusable="false"
    >
      {title && <title>{title}</title>}
      <path d={PATHS[name]} />
    </svg>
  );
}
